import {
  ADD_RESOURCES_BUYLIST,
  ADD_RESOURCES_REPORT,
  CHANGE_BOARD_RESOURCE,
  DELETE_RESOURCES_BUYLIST,
  GET_BOARD_RESOURCES,
  GET_BOARD_RESOURCES_SCHEMA,
  GET_BOARD_TASK_MAIN_RESOURCES,
  GET_RESOURCES_BUYLIST,
  GET_RESOURCES_BUYLISTS,
  GET_RESOURCES_REPORTS,
  GET_RESOURCE_CATEGORIES,
  GET_RESOURCE_TYPES,
  GET_TASK_RESOURCES_BUYLIST,
} from "./ResourcesType";

export const ResourcesReducer = (
  state = {
    Categories: [],
    Resources: [],
    ResourceTypes: [],
    TasksResources: [],
    ResourceReports: [],
    BuyList: [],
    TasksBuyList: [],
  },
  action
) => {
  switch (action.type) {
    case GET_BOARD_RESOURCES_SCHEMA: {
      return {
        ...state,
        Categories: action.Payload.Categories,
        Resources: action.Payload.Resource,
        TasksResources: action.Payload.FinalTasksData,
      };
    }
    case GET_RESOURCE_CATEGORIES: {
      return {
        ...state,
        Categories: action.Payload,
      };
    }
    case GET_RESOURCE_TYPES: {
      return {
        ...state,
        ResourceTypes: action.Payload,
      };
    }
    case GET_BOARD_RESOURCES: {
      return {
        ...state,
        Resources: action.Payload,
      };
    }
    case GET_BOARD_TASK_MAIN_RESOURCES: {
      return {
        ...state,
        TasksDocs: action.Payload,
      };
    }
    case CHANGE_BOARD_RESOURCE: {
      const Resources1 = state.Resources;
      const Find1 = Resources1.find((item) => item._id === action.Payload._id);
      const Index1 = Resources1.indexOf(Find1);
      Resources1[Index1] = action.Payload;
      return {
        ...state,
        Resources: [...Resources1],
      };
    }
    case GET_RESOURCES_REPORTS: {
      return {
        ...state,
        ResourceReports: action.Payload,
      };
    }
    case ADD_RESOURCES_REPORT: {
      return {
        ...state,
        ResourceReports: [...state.ResourceReports, action.Payload],
      };
    }
    case GET_RESOURCES_BUYLISTS: {
      return {
        ...state,
        BuyList: action.Payload.ResourcesBuyLists,
        TasksBuyList: action.Payload.FinalTasksData,
      };
    }
    case ADD_RESOURCES_BUYLIST: {
      return {
        ...state,
        BuyList: [...state.BuyList, action.Payload],
      };
    }
    case GET_RESOURCES_BUYLIST: {
      const BuyList2 = state.BuyList.map((item) =>
        item._id === action.Payload._id ? action.Payload : item,
      );
      return {
        ...state,
        BuyList: BuyList2,
      };
    }
    case DELETE_RESOURCES_BUYLIST: {
      const BuyList3 = state.BuyList;
      const Filter3 = BuyList3.filter((item) => item._id !== action.Payload);
      return {
        ...state,
        BuyList: [...Filter3],
      };
    }
    default: {
      return state;
    }
  }
};
